import React, { useEffect, useRef } from 'react';

export interface SenhaStepProps {
  senha: string;
  setSenha: (v: string) => void;
  erro: boolean;
  setErro: (v: boolean) => void;
  shake: boolean;
  onNext: () => void;
}

export function SenhaStep({ senha, setSenha, erro, setErro, shake, onNext }: SenhaStepProps) {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => { ref.current?.focus(); }, []);

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:36 }}>
      <div>
        <div style={{ fontSize:12,fontWeight:700,color:'#7c3aed',letterSpacing:'0.15em',textTransform:'uppercase',marginBottom:12 }}>Etapa 1 de 4</div>
        <h1 style={{ fontSize:44,fontWeight:900,color:'#fff',letterSpacing:'-0.03em',lineHeight:1.1,margin:0 }}>Área Restrita</h1>
        <p style={{ fontSize:16,color:'#94a3b8',marginTop:12,lineHeight:1.6 }}>Digite a senha de acesso para configurar o Simulation Studio.</p>
      </div>
      <div className={shake ? 'shake' : ''}>
        <div style={{ background:'rgba(255,255,255,0.05)', border:`1px solid ${erro ? 'rgba(248,113,113,0.5)' : 'rgba(124,58,237,0.35)'}`, borderRadius:16, padding:'4px 4px 4px 20px', display:'flex', alignItems:'center', gap:12 }}>
          <span style={{ fontSize:20,opacity:0.6 }}>🔐</span>
          <input
            ref={ref}
            type="password"
            placeholder="Senha de acesso"
            value={senha}
            onChange={e => { setSenha(e.target.value); setErro(false); }}
            onKeyDown={e => e.key === 'Enter' && onNext()}
            style={{ flex:1,background:'none',border:'none',outline:'none',fontSize:22,fontWeight:600,color:'#f1f5f9',letterSpacing:'0.1em',padding:'14px 0' }}
          />
          <button
            onClick={onNext}
            style={{ width:52,height:52,borderRadius:12,border:'none',cursor:'pointer', background:'linear-gradient(135deg,#7c3aed,#4f46e5)',color:'#fff',fontSize:22,flexShrink:0, boxShadow:'0 4px 16px rgba(124,58,237,0.45)',display:'flex',alignItems:'center',justifyContent:'center' }}
          >→</button>
        </div>
        {erro && <div style={{ color:'#f87171',fontSize:13,marginTop:10,paddingLeft:4 }}>Senha incorreta. Tente novamente.</div>}
      </div>
    </div>
  );
}
